import * as React from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import { Servicio, SolicitudAdminServicio } from "../modelo/AdminServicio";
import { ProcesoAdmin } from "../../config_general/modelo/ProcesoAdmin";
import { gestionarServicio } from "../modulos/adminServicioActions";
import { ModalGestionarServicio } from "./ModalGestionarServicio";
import AccionAdministracion from "../../config_general/componentes/AccionAdministracion";
import { IconoAccion } from "../../config_general/modelo/IconoAccion";

class ModalAdminServicios extends React.Component<any, any> {

    constructor(props: any) {
        super(props);

        this.state = {
            showModalCrear: false,
            showModalActualizar: false
        };

    }

    render() {
        return (
            <div>
                <button type="button" className="btns btns-glyphicon" onClick={this.mostrarModalCrear}
                    disabled={this.state.showModalCrear}>
                    <AccionAdministracion texto="Crear" icono={IconoAccion.CREAR} />
                </button>
                <button type="button" className="btns btns-glyphicon" onClick={this.mostrarModalActualizar}
                    disabled={this.state.showModalActualizar}>
                    <AccionAdministracion texto="Editar" icono={IconoAccion.EDITAR} />
                </button>
                {this.crearParametro()}
                {this.actualizarParametro()}
            </div >
        );
    }

    crearParametro = () => {
        return (
            <ModalGestionarServicio
                titulo={"Crear Servicio"}
                esCrear
                consecutivo={undefined}
                nombreServicio={this.props.nombreServicio}
                descripcion={this.props.descripcion}
                urlServicio={this.props.urlServicio}
                tablaTraza={this.props.tablaTraza}
                snEnvioSat={this.props.snEnvioSat}
                snReciboSat={this.props.snReciboSat}
                snEncriptarEnvioSat={this.props.snEncriptarEnvioSat}
                snEncriptarReciboSat={this.props.snEncriptarReciboSat}
                fechaAlta={undefined}
                fechaBaja={this.props.fechaBaja}
                fechaIngresa={this.props.fechaIngresa}
                intentos={this.props.intentos}
                tiempoIntento={this.props.tiempoIntento}
                servicioMinisterio={this.props.servicioMinisterio}
                dniIngreso={this.props.dniIngreso}
                snGestionable={this.props.snGestionable}
                textoSelector={undefined}
                servicioDependientes={undefined}
                idCliente={undefined}
                show={this.state.showModalCrear}
                onAceptar={this.crear}
                onCancelar={this.cerrarModalCrear} />

        );
    }

    actualizarParametro = () => {
        return (
            <ModalGestionarServicio
                titulo={"Actualizar Servicio"}
                esCrear={false}
                consecutivo={this.props.consecutivo}
                nombreServicio={this.props.nombreServicio}
                descripcion={this.props.descripcion}
                urlServicio={this.props.urlServicio}
                tablaTraza={this.props.tablaTraza}
                snEnvioSat={this.props.snEnvioSat}
                snReciboSat={this.props.snReciboSat}
                snEncriptarEnvioSat={this.props.snEncriptarEnvioSat}
                snEncriptarReciboSat={this.props.snEncriptarReciboSat}
                fechaAlta={this.props.fechaAlta}
                fechaBaja={this.props.fechaBaja}
                fechaIngresa={this.props.fechaIngresa}
                intentos={this.props.intentos}
                tiempoIntento={this.props.tiempoIntento}
                servicioMinisterio={this.props.servicioMinisterio}
                dniIngreso={this.props.dniIngreso}
                snGestionable={this.props.snGestionable}
                textoSelector={this.props.textoSelector}
                servicioDependientes={this.props.servicioDependientes}
                idCliente={this.props.idCliente}
                show={this.state.showModalActualizar}
                onAceptar={this.actualizar}
                onCancelar={this.cerrarModalActualizar} />

        );
    }

    actualizar = (servicio: Servicio) => {
        const solicitud: SolicitudAdminServicio = {
            dniModifica: this.props.dniUsuarioGestionLogin,
            datos: servicio,
            tipoProceso: ProcesoAdmin[1].codigo
        };

        this.cerrarModalActualizar();
        this.props.dispatch(gestionarServicio(solicitud));
    };

    crear = (servicio: Servicio) => {
        const solicitud: SolicitudAdminServicio = {
            dniModifica: this.props.dniUsuarioGestionLogin,
            datos: servicio,
            tipoProceso: ProcesoAdmin[0].codigo
        };

        this.cerrarModalCrear();
        this.props.dispatch(gestionarServicio(solicitud));
    };

    cerrarModalActualizar = () => {
        this.setState({ showModalActualizar: false });
    };

    mostrarModalActualizar = () => {
        this.setState({ showModalActualizar: true });
    };

    cerrarModalCrear = () => {
        this.setState({ showModalCrear: false });
    };

    mostrarModalCrear = () => {
        this.setState({ showModalCrear: true });
    };
}

export default connect((store: any, props: any) => {
    return {
        ...props,
        dniUsuarioGestionLogin: R.pathOr(undefined, ["inicio", "dniLogin"])(store)
    };
})(ModalAdminServicios);


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/config_servicios/componentes/ModalAdminServicios.tsx